export const EUR_USD_FALLBACK_RATE = 1.1648

export const EUR_USD_HISTORY = {
    '2025-13-11': 1.1648,
    '2025-12-11': 1.1593,
    '2025-11-11': 1.1582,
    '2025-10-11': 1.1557,
    '2025-07-11': 1.1566,
    '2025-06-11': 1.1548,
    '2025-05-11': 1.1492,
    '2025-04-11': 1.1483,
    '2025-03-11': 1.152,
    '2025-31-10': 1.1536,
    '2025-30-10': 1.1566,
    '2025-29-10': 1.1601,
    '2025-28-10': 1.1652,
    '2025-27-10': 1.1645,
    '2025-24-10': 1.1626,
    '2025-23-10': 1.1618,
    '2025-22-10': 1.1611,
    '2025-21-10': 1.1599,
    '2025-20-10': 1.1641,
    '2025-17-10': 1.1652,
    '2025-16-10': 1.1688,
    '2025-15-10': 1.1648,
    '2025-14-10': 1.1607,
    '2025-13-10': 1.157,
    '2025-10-10': 1.162,
    '2025-09-10': 1.1565,
    '2025-08-10': 1.1628,
    '2025-07-10': 1.1657,
    '2025-06-10': 1.171,
    '2025-03-10': 1.1743,
    '2025-02-10': 1.1716,
    '2025-01-10': 1.173,
    '2025-30-09': 1.1734,
    '2025-29-09': 1.1727,
    '2025-26-09': 1.1702,
    '2025-25-09': 1.1667,
    '2025-24-09': 1.1738,
    '2025-23-09': 1.1816,
    '2025-22-09': 1.1803,
    '2025-19-09': 1.1746,
    '2025-18-09': 1.1788,
    '2025-17-09': 1.1813,
    '2025-16-09': 1.1868,
    '2025-15-09': 1.1761,
    '2025-12-09': 1.1734,
    '2025-11-09': 1.1734,
    '2025-10-09': 1.1695,
    '2025-09-09': 1.1708,
    '2025-08-09': 1.1764,
    '2025-05-09': 1.1719,
    '2025-04-09': 1.165,
    '2025-03-09': 1.1662,
    '2025-02-09': 1.164,
    '2025-01-09': 1.1711,
    '2025-29-08': 1.1686,
    '2025-28-08': 1.1683,
    '2025-27-08': 1.1639,
    '2025-26-08': 1.1643,
    '2025-25-08': 1.1618,
    '2025-22-08': 1.1717,
    '2025-21-08': 1.1606,
    '2025-20-08': 1.1652,
    '2025-19-08': 1.1647,
    '2025-18-08': 1.1661,
    '2025-15-08': 1.1698,
    '2025-14-08': 1.1648,
    '2025-13-08': 1.1706,
    '2025-12-08': 1.1673,
    '2025-11-08': 1.1616,
    '2025-08-08': 1.164,
    '2025-07-08': 1.1666,
    '2025-06-08': 1.166,
    '2025-05-08': 1.1576,
    '2025-04-08': 1.1571,
    '2025-01-08': 1.1586,
    '2025-31-07': 1.1416,
    '2025-30-07': 1.1406,
    '2025-29-07': 1.1546,
    '2025-28-07': 1.1589,
    '2025-25-07': 1.1742,
    '2025-24-07': 1.1755,
    '2025-23-07': 1.1772,
    '2025-22-07': 1.1755,
    '2025-21-07': 1.1696,
    '2025-18-07': 1.1626,
    '2025-17-07': 1.1596,
    '2025-16-07': 1.1635,
    '2025-15-07': 1.1601,
    '2025-14-07': 1.1665,
    '2025-11-07': 1.169,
    '2025-10-07': 1.17,
    '2025-09-07': 1.1721,
    '2025-08-07': 1.1726,
    '2025-07-07': 1.1709,
    '2025-04-07': 1.1779,
    '2025-03-07': 1.1757,
    '2025-02-07': 1.1799,
    '2025-01-07': 1.1807,
    '2025-30-06': 1.1787,
    '2025-27-06': 1.172,
    '2025-26-06': 1.17,
    '2025-25-06': 1.166,
    '2025-24-06': 1.161,
    '2025-23-06': 1.1578,
    '2025-20-06': 1.1523,
    '2025-19-06': 1.1495,
    '2025-18-06': 1.1481,
    '2025-17-06': 1.1481,
    '2025-16-06': 1.1562,
    '2025-13-06': 1.1553,
    '2025-12-06': 1.1585,
    '2025-11-06': 1.1488,
    '2025-10-06': 1.1425,
    '2025-09-06': 1.1421,
    '2025-06-06': 1.1395,
    '2025-05-06': 1.1445,
    '2025-04-06': 1.1418,
    '2025-03-06': 1.1372,
    '2025-02-06': 1.1442,
    '2025-30-05': 1.1348,
    '2025-29-05': 1.1372,
    '2025-28-05': 1.1293,
    '2025-27-05': 1.1329,
    '2025-26-05': 1.1388,
    '2025-23-05': 1.1365,
    '2025-22-05': 1.1281,
    '2025-21-05': 1.1331,
    '2025-20-05': 1.1283,
    '2025-19-05': 1.1244,
    '2025-16-05': 1.1164,
    '2025-15-05': 1.1189,
    '2025-14-05': 1.1175,
    '2025-13-05': 1.1186,
    '2025-12-05': 1.1088,
    '2025-09-05': 1.1248,
    '2025-08-05': 1.1228,
    '2025-07-05': 1.13,
    '2025-06-05': 1.137,
    '2025-05-05': 1.1315,
    '2025-02-05': 1.1296,
    '2025-01-05': 1.1292,
    '2025-30-04': 1.1329,
    '2025-29-04': 1.1386,
    '2025-28-04': 1.1422,
    '2025-25-04': 1.1365,
    '2025-24-04': 1.1389,
    '2025-23-04': 1.1315,
    '2025-22-04': 1.142,
    '2025-21-04': 1.1513,
    '2025-18-04': 1.1391,
    '2025-17-04': 1.1363,
    '2025-16-04': 1.1398,
    '2025-15-04': 1.1281,
    '2025-14-04': 1.1349,
    '2025-11-04': 1.136,
    '2025-10-04': 1.1197,
    '2025-09-04': 1.0951,
    '2025-08-04': 1.0956,
    '2025-07-04': 1.0904,
    '2025-04-04': 1.0955,
    '2025-03-04': 1.105,
    '2025-02-04': 1.0855,
    '2025-01-04': 1.0793,
    '2025-31-03': 1.0817,
    '2025-28-03': 1.0827,
    '2025-27-03': 1.0801,
    '2025-26-03': 1.0752,
    '2025-25-03': 1.0791,
    '2025-24-03': 1.08,
    '2025-21-03': 1.0814,
    '2025-20-03': 1.0851,
    '2025-19-03': 1.0901,
    '2025-18-03': 1.0943,
    '2025-17-03': 1.0921,
    '2025-14-03': 1.0879,
    '2025-13-03': 1.0852,
    '2025-12-03': 1.0886,
    '2025-11-03': 1.0918,
    '2025-10-03': 1.0832,
    '2025-07-03': 1.0832,
    '2025-06-03': 1.0783,
    '2025-05-03': 1.079,
    '2025-04-03': 1.0624,
    '2025-03-03': 1.0486,
    '2025-28-02': 1.0375,
    '2025-27-02': 1.0397,
    '2025-26-02': 1.0483,
    '2025-25-02': 1.0513,
    '2025-24-02': 1.0466,
    '2025-21-02': 1.0458,
    '2025-20-02': 1.05,
    '2025-19-02': 1.0421,
    '2025-18-02': 1.0445,
    '2025-17-02': 1.0482,
    '2025-14-02': 1.0491,
    '2025-13-02': 1.0464,
    '2025-12-02': 1.0382,
    '2025-11-02': 1.036,
    '2025-10-02': 1.0306,
    '2025-07-02': 1.0327,
    '2025-06-02': 1.0381,
    '2025-05-02': 1.0402,
    '2025-04-02': 1.0377,
    '2025-03-02': 1.0344,
    '2025-31-01': 1.0362,
    '2025-30-01': 1.039,
    '2025-29-01': 1.042,
    '2025-28-01': 1.0428,
    '2025-27-01': 1.0491,
    '2025-24-01': 1.0493,
    '2025-23-01': 1.0415,
    '2025-22-01': 1.0407,
    '2025-21-01': 1.0429,
    '2025-20-01': 1.0414,
    '2025-17-01': 1.0271,
    '2025-16-01': 1.0298,
    '2025-15-01': 1.0289,
    '2025-14-01': 1.0307,
    '2025-13-01': 1.0244,
    '2025-10-01': 1.0244,
    '2025-09-01': 1.0298,
    '2025-08-01': 1.0318,
    '2025-07-01': 1.0339,
    '2025-06-01': 1.039,
    '2025-03-01': 1.0308,
    '2025-02-01': 1.0265,
    '2025-01-01': 1.0355,
    '2024-31-12': 1.0353,
    '2024-30-12': 1.0407,
    '2024-27-12': 1.0427,
    '2024-26-12': 1.0422,
    '2024-25-12': 1.0404,
    '2024-24-12': 1.0397,
    '2024-23-12': 1.0405,
    '2024-20-12': 1.0429,
    '2024-19-12': 1.0362,
    '2024-18-12': 1.0352,
    '2024-17-12': 1.0489,
    '2024-16-12': 1.051,
    '2024-13-12': 1.0502,
    '2024-12-12': 1.0467,
    '2024-11-12': 1.0494,
    '2024-10-12': 1.0526,
    '2024-09-12': 1.0552,
    '2024-06-12': 1.0568,
    '2024-05-12': 1.0586,
    '2024-04-12': 1.051,
    '2024-03-12': 1.0509,
    '2024-02-12': 1.0497,
    '2024-29-11': 1.0575,
    '2024-28-11': 1.0553,
    '2024-27-11': 1.0564,
    '2024-26-11': 1.0486,
    '2024-25-11': 1.0494,
    '2024-22-11': 1.0417,
    '2024-21-11': 1.0473,
    '2024-20-11': 1.0543,
    '2024-19-11': 1.0595,
    '2024-18-11': 1.0599,
    '2024-15-11': 1.0541,
    '2024-14-11': 1.053,
    '2024-13-11': 1.0563,
    '2024-12-11': 1.0623,
    '2024-11-11': 1.0654,
    '2024-08-11': 1.0718,
    '2024-07-11': 1.0804,
    '2024-06-11': 1.0728,
    '2024-05-11': 1.093,
    '2024-04-11': 1.0877,
    '2024-01-11': 1.0834,
    '2024-31-10': 1.0883,
    '2024-30-10': 1.0855,
    '2024-29-10': 1.0818,
    '2024-28-10': 1.0812,
    '2024-25-10': 1.0793,
    '2024-24-10': 1.0827,
    '2024-23-10': 1.0781,
    '2024-22-10': 1.0797,
    '2024-21-10': 1.0815,
    '2024-18-10': 1.0866,
    '2024-17-10': 1.0831,
    '2024-16-10': 1.0861,
    '2024-15-10': 1.089,
    '2024-14-10': 1.0909,
    '2024-11-10': 1.0937,
    '2024-10-10': 1.0935,
    '2024-09-10': 1.0939,
    '2024-08-10': 1.098,
    '2024-07-10': 1.0974,
    '2024-04-10': 1.0976,
    '2024-03-10': 1.1031,
    '2024-02-10': 1.1045,
    '2024-01-10': 1.1067,
    '2024-30-09': 1.1134,
    '2024-27-09': 1.1163,
    '2024-26-09': 1.1176,
    '2024-25-09': 1.1132,
    '2024-24-09': 1.118,
    '2024-23-09': 1.1112,
    '2024-20-09': 1.1162,
    '2024-19-09': 1.1161,
    '2024-18-09': 1.1118,
    '2024-17-09': 1.1113,
    '2024-16-09': 1.1132,
    '2024-13-09': 1.1076,
    '2024-12-09': 1.1074,
    '2024-11-09': 1.1011,
    '2024-10-09': 1.1019,
    '2024-09-09': 1.1034,
    '2024-06-09': 1.1083,
    '2024-05-09': 1.111,
    '2024-04-09': 1.1082,
    '2024-03-09': 1.1043,
    '2024-02-09': 1.1071,
    '2024-30-08': 1.1047,
    '2024-29-08': 1.1077,
    '2024-28-08': 1.112,
    '2024-27-08': 1.1184,
    '2024-26-08': 1.1161,
    '2024-23-08': 1.119,
    '2024-22-08': 1.1112,
    '2024-21-08': 1.115,
    '2024-20-08': 1.113,
    '2024-19-08': 1.1085,
    '2024-16-08': 1.1028,
    '2024-15-08': 1.0971,
    '2024-14-08': 1.1012,
    '2024-13-08': 1.0992,
    '2024-12-08': 1.0931,
    '2024-09-08': 1.0916,
    '2024-08-08': 1.0918,
    '2024-07-08': 1.0921,
    '2024-06-08': 1.093,
    '2024-05-08': 1.0952,
    '2024-02-08': 1.0908,
    '2024-01-08': 1.0791,
    '2024-31-07': 1.0825,
    '2024-30-07': 1.0815,
    '2024-29-07': 1.0819,
    '2024-26-07': 1.0857,
    '2024-25-07': 1.0844,
    '2024-24-07': 1.0839,
    '2024-23-07': 1.0851,
    '2024-22-07': 1.0889,
    '2024-19-07': 1.0877,
    '2024-18-07': 1.0896,
    '2024-17-07': 1.0937,
    '2024-16-07': 1.0897,
    '2024-15-07': 1.0894,
    '2024-12-07': 1.0906,
    '2024-11-07': 1.0865,
    '2024-10-07': 1.083,
    '2024-09-07': 1.0812,
    '2024-08-07': 1.0822,
    '2024-05-07': 1.0836,
    '2024-04-07': 1.081,
    '2024-03-07': 1.0786,
    '2024-02-07': 1.0744,
    '2024-01-07': 1.0738,
    '2024-28-06': 1.0713,
    '2024-27-06': 1.0702,
    '2024-26-06': 1.0679,
    '2024-25-06': 1.0713,
    '2024-24-06': 1.0732,
    '2024-21-06': 1.0691,
    '2024-20-06': 1.07,
    '2024-19-06': 1.0742,
    '2024-18-06': 1.0738,
    '2024-17-06': 1.0734,
    '2024-14-06': 1.07,
    '2024-13-06': 1.0735,
    '2024-12-06': 1.0807,
    '2024-11-06': 1.0739,
    '2024-10-06': 1.0763,
    '2024-07-06': 1.08,
    '2024-06-06': 1.0888,
    '2024-05-06': 1.0868,
    '2024-04-06': 1.0878,
    '2024-03-06': 1.0902,
    '2024-31-05': 1.0841,
    '2024-30-05': 1.0832,
    '2024-29-05': 1.08,
    '2024-28-05': 1.0855,
    '2024-27-05': 1.0858,
    '2024-24-05': 1.0845,
    '2024-23-05': 1.0813,
    '2024-22-05': 1.0821,
    '2024-21-05': 1.0854,
    '2024-20-05': 1.0855,
    '2024-17-05': 1.087,
    '2024-16-05': 1.0865,
    '2024-15-05': 1.0882,
    '2024-14-05': 1.0818,
    '2024-13-05': 1.0788,
    '2024-10-05': 1.0769,
    '2024-09-05': 1.0781,
    '2024-08-05': 1.0745,
    '2024-07-05': 1.0752,
    '2024-06-05': 1.0768,
    '2024-03-05': 1.0758,
    '2024-02-05': 1.0725,
    '2024-01-05': 1.0709,
    '2024-30-04': 1.0665,
    '2024-29-04': 1.0719,
    '2024-26-04': 1.0692,
    '2024-25-04': 1.0729,
    '2024-24-04': 1.0697,
    '2024-23-04': 1.0699,
    '2024-22-04': 1.0654,
    '2024-19-04': 1.0654,
    '2024-18-04': 1.0643,
    '2024-17-04': 1.0671,
    '2024-16-04': 1.0617,
    '2024-15-04': 1.0622,
    '2024-12-04': 1.0642,
    '2024-11-04': 1.0724,
    '2024-10-04': 1.0742,
    '2024-09-04': 1.0855,
    '2024-08-04': 1.0858,
    '2024-05-04': 1.0835,
    '2024-04-04': 1.0835,
    '2024-03-04': 1.0835,
    '2024-02-04': 1.0768,
    '2024-01-04': 1.0743,
    '2024-29-03': 1.0793,
    '2024-28-03': 1.0787,
    '2024-27-03': 1.0826,
    '2024-26-03': 1.083,
    '2024-25-03': 1.0836,
    '2024-22-03': 1.0805,
    '2024-21-03': 1.086,
    '2024-20-03': 1.0918,
    '2024-19-03': 1.0865,
    '2024-18-03': 1.0871,
    '2024-15-03': 1.0887,
    '2024-14-03': 1.0881,
    '2024-13-03': 1.0946,
    '2024-12-03': 1.0924,
    '2024-11-03': 1.0926,
    '2024-08-03': 1.0937,
    '2024-07-03': 1.0946,
    '2024-06-03': 1.0897,
    '2024-05-03': 1.0855,
    '2024-04-03': 1.0854,
    '2024-01-03': 1.0837,
    '2024-29-02': 1.0803,
    '2024-28-02': 1.0836,
    '2024-27-02': 1.0844,
    '2024-26-02': 1.0847,
    '2024-23-02': 1.0818,
    '2024-22-02': 1.0823,
    '2024-21-02': 1.0817,
    '2024-20-02': 1.0803,
    '2024-19-02': 1.0777,
    '2024-16-02': 1.0774,
    '2024-15-02': 1.0771,
    '2024-14-02': 1.0725,
    '2024-13-02': 1.0709,
    '2024-12-02': 1.0771,
    '2024-09-02': 1.0782,
    '2024-08-02': 1.0776,
    '2024-07-02': 1.0771,
    '2024-06-02': 1.0754,
    '2024-05-02': 1.0741,
    '2024-02-02': 1.0784,
    '2024-01-02': 1.0872,
    '2024-31-01': 1.0816,
    '2024-30-01': 1.084,
    '2024-29-01': 1.0833,
    '2024-26-01': 1.0852,
    '2024-25-01': 1.0846,
    '2024-24-01': 1.0883,
    '2024-23-01': 1.0851,
    '2024-22-01': 1.0881,
    '2024-19-01': 1.0897,
    '2024-18-01': 1.0874,
    '2024-17-01': 1.0881,
    '2024-16-01': 1.0874,
    '2024-15-01': 1.0948,
    '2024-12-01': 1.0949,
    '2024-11-01': 1.097,
    '2024-10-01': 1.0971,
    '2024-09-01': 1.0931,
    '2024-08-01': 1.0949,
    '2024-05-01': 1.0941,
    '2024-04-01': 1.0943,
    '2024-03-01': 1.0921,
    '2024-02-01': 1.0947,
    '2024-01-01': 1.1044,
    '2023-29-12': 1.1036,
    '2023-28-12': 1.1059,
    '2023-27-12': 1.1103,
    '2023-26-12': 1.1042,
    '2023-25-12': 1.1007,
    '2023-22-12': 1.101,
    '2023-21-12': 1.1008,
    '2023-20-12': 1.0938,
    '2023-19-12': 1.098,
    '2023-18-12': 1.0922,
    '2023-15-12': 1.0894,
    '2023-14-12': 1.0991,
    '2023-13-12': 1.0873,
    '2023-12-12': 1.0792,
    '2023-11-12': 1.0761,
    '2023-08-12': 1.0761,
    '2023-07-12': 1.0792,
    '2023-06-12': 1.0762,
    '2023-05-12': 1.0795,
    '2023-04-12': 1.0836,
    '2023-01-12': 1.0881,
    '2023-30-11': 1.0886,
    '2023-29-11': 1.0968,
    '2023-28-11': 1.099,
    '2023-27-11': 1.0953,
    '2023-24-11': 1.0939,
    '2023-23-11': 1.0904,
    '2023-22-11': 1.0887,
    '2023-21-11': 1.0909,
    '2023-20-11': 1.0938,
    '2023-17-11': 1.0907,
    '2023-16-11': 1.085,
    '2023-15-11': 1.0846,
    '2023-14-11': 1.0879,
    '2023-13-11': 1.0697,
    '2023-10-11': 1.0681,
    '2023-09-11': 1.0666,
    '2023-08-11': 1.0707,
    '2023-07-11': 1.0699,
    '2023-06-11': 1.0715,
    '2023-03-11': 1.0729,
    '2023-02-11': 1.062,
    '2023-01-11': 1.0568,
    '2023-31-10': 1.0576,
    '2023-30-10': 1.0613,
    '2023-27-10': 1.0564,
    '2023-26-10': 1.056,
    '2023-25-10': 1.0563,
    '2023-24-10': 1.0588,
    '2023-23-10': 1.0668,
    '2023-20-10': 1.0593,
    '2023-19-10': 1.0579,
    '2023-18-10': 1.0535,
    '2023-17-10': 1.0575,
    '2023-16-10': 1.0558,
    '2023-13-10': 1.0509,
    '2023-12-10': 1.0526,
    '2023-11-10': 1.0617,
    '2023-10-10': 1.0603,
    '2023-09-10': 1.0565,
    '2023-06-10': 1.0586,
    '2023-05-10': 1.0548,
    '2023-04-10': 1.0503,
    '2023-03-10': 1.0465,
    '2023-02-10': 1.0476,
    '2023-29-09': 1.057,
    '2023-28-09': 1.0559,
    '2023-27-09': 1.05,
    '2023-26-09': 1.057,
    '2023-25-09': 1.059,
    '2023-22-09': 1.0652,
    '2023-21-09': 1.0658,
    '2023-20-09': 1.0659,
    '2023-19-09': 1.0677,
    '2023-18-09': 1.069,
    '2023-15-09': 1.0655,
    '2023-14-09': 1.0641,
    '2023-13-09': 1.0728,
    '2023-12-09': 1.0752,
    '2023-11-09': 1.0748,
    '2023-08-09': 1.0699,
    '2023-07-09': 1.0699,
    '2023-06-09': 1.0727,
    '2023-05-09': 1.072,
    '2023-04-09': 1.0794,
    '2023-01-09': 1.0773,
    '2023-31-08': 1.0841,
    '2023-30-08': 1.0924,
    '2023-29-08': 1.0877,
    '2023-28-08': 1.0817,
    '2023-25-08': 1.08,
    '2023-24-08': 1.0809,
    '2023-23-08': 1.0859,
    '2023-22-08': 1.0844,
    '2023-21-08': 1.0891,
    '2023-18-08': 1.0865,
    '2023-17-08': 1.0871,
    '2023-16-08': 1.0874,
    '2023-15-08': 1.0904,
    '2023-14-08': 1.0904,
    '2023-11-08': 1.0944,
    '2023-10-08': 1.0979,
    '2023-09-08': 1.0973,
    '2023-08-08': 1.0954,
    '2023-07-08': 1.1002,
    '2023-04-08': 1.101,
    '2023-03-08': 1.0944,
    '2023-02-08': 1.0936,
    '2023-01-08': 1.0982,
    '2023-31-07': 1.0993,
    '2023-28-07': 1.1015,
    '2023-27-07': 1.0973,
    '2023-26-07': 1.1083,
    '2023-25-07': 1.1053,
    '2023-24-07': 1.1062,
    '2023-21-07': 1.1123,
    '2023-20-07': 1.1128,
    '2023-19-07': 1.1198,
    '2023-18-07': 1.1226,
    '2023-17-07': 1.1234,
    '2023-14-07': 1.1227,
    '2023-13-07': 1.1224,
    '2023-12-07': 1.1128,
    '2023-11-07': 1.1006,
    '2023-10-07': 1.0999,
    '2023-07-07': 1.0967,
    '2023-06-07': 1.0887,
    '2023-05-07': 1.0851,
    '2023-04-07': 1.0877,
    '2023-03-07': 1.0911,
    '2023-30-06': 1.091,
    '2023-29-06': 1.0864,
    '2023-28-06': 1.0911,
    '2023-27-06': 1.0959,
    '2023-26-06': 1.0904,
    '2023-23-06': 1.0889,
    '2023-22-06': 1.0956,
    '2023-21-06': 1.0984,
    '2023-20-06': 1.0916,
    '2023-19-06': 1.0922,
    '2023-16-06': 1.0933,
    '2023-15-06': 1.0945,
    '2023-14-06': 1.0831,
    '2023-13-06': 1.0791,
    '2023-12-06': 1.0757,
    '2023-09-06': 1.0747,
    '2023-08-06': 1.0781,
    '2023-07-06': 1.0697,
    '2023-06-06': 1.0691,
    '2023-05-06': 1.0712,
    '2023-02-06': 1.0706,
    '2023-01-06': 1.0761,
    '2023-31-05': 1.0688,
    '2023-30-05': 1.0733,
    '2023-29-05': 1.0705,
    '2023-26-05': 1.0724,
    '2023-25-05': 1.0719,
    '2023-24-05': 1.0748,
    '2023-23-05': 1.0768,
    '2023-22-05': 1.0811,
    '2023-19-05': 1.0802,
    '2023-18-05': 1.0769,
    '2023-17-05': 1.0839,
    '2023-16-05': 1.0861,
    '2023-15-05': 1.0872,
    '2023-12-05': 1.0848,
    '2023-11-05': 1.0914,
    '2023-10-05': 1.098,
    '2023-09-05': 1.096,
    '2023-08-05': 1.1004,
    '2023-05-05': 1.1017,
    '2023-04-05': 1.1011,
    '2023-03-05': 1.1059,
    '2023-02-05': 1.0999,
    '2023-01-05': 1.0975,
    '2023-28-04': 1.102,
    '2023-27-04': 1.1027,
    '2023-26-04': 1.104,
    '2023-25-04': 1.0972,
    '2023-24-04': 1.1041,
    '2023-21-04': 1.0987,
    '2023-20-04': 1.0967,
    '2023-19-04': 1.0954,
    '2023-18-04': 1.0971,
    '2023-17-04': 1.0926,
    '2023-14-04': 1.1,
    '2023-13-04': 1.1044,
    '2023-12-04': 1.0989,
    '2023-11-04': 1.091,
    '2023-10-04': 1.0859,
    '2023-07-04': 1.0897,
    '2023-06-04': 1.092,
    '2023-05-04': 1.0903,
    '2023-04-04': 1.0952,
    '2023-03-04': 1.0895,
    '2023-31-03': 1.0839,
    '2023-30-03': 1.0901,
    '2023-29-03': 1.0843,
    '2023-28-03': 1.0843,
    '2023-27-03': 1.0796,
    '2023-24-03': 1.0759,
    '2023-23-03': 1.083,
    '2023-22-03': 1.0855,
    '2023-21-03': 1.0767,
    '2023-20-03': 1.0719,
    '2023-17-03': 1.0666,
    '2023-16-03': 1.0605,
    '2023-15-03': 1.0575,
    '2023-14-03': 1.0732,
    '2023-13-03': 1.0729,
    '2023-10-03': 1.0643,
    '2023-09-03': 1.058,
    '2023-08-03': 1.0544,
    '2023-07-03': 1.0547,
    '2023-06-03': 1.0678,
    '2023-03-03': 1.0632,
    '2023-02-03': 1.0596,
    '2023-01-03': 1.0665,
    '2023-28-02': 1.0576,
    '2023-27-02': 1.0607,
    '2023-24-02': 1.0546,
    '2023-23-02': 1.0595,
    '2023-22-02': 1.0601,
    '2023-21-02': 1.0646,
    '2023-20-02': 1.0682,
    '2023-17-02': 1.0694,
    '2023-16-02': 1.0668,
    '2023-15-02': 1.0689,
    '2023-14-02': 1.0735,
    '2023-13-02': 1.072,
    '2023-10-02': 1.0675,
    '2023-09-02': 1.0736,
    '2023-08-02': 1.0709,
    '2023-07-02': 1.0723,
    '2023-06-02': 1.073,
    '2023-03-02': 1.0793,
    '2023-02-02': 1.091,
    '2023-01-02': 1.0989,
    '2023-31-01': 1.0862,
    '2023-30-01': 1.0844,
    '2023-27-01': 1.0867,
    '2023-26-01': 1.0889,
    '2023-25-01': 1.0915,
    '2023-24-01': 1.0885,
    '2023-23-01': 1.0868,
    '2023-20-01': 1.0855,
    '2023-19-01': 1.0827,
    '2023-18-01': 1.0792,
    '2023-17-01': 1.0788,
    '2023-16-01': 1.0816,
    '2023-13-01': 1.0828,
    '2023-12-01': 1.0846,
    '2023-11-01': 1.0755,
    '2023-10-01': 1.0734,
    '2023-09-01': 1.0728,
    '2023-06-01': 1.0644,
    '2023-05-01': 1.052,
    '2023-04-01': 1.0599,
    '2023-03-01': 1.0546,
    '2023-02-01': 1.0662,
    '2022-30-12': 1.0702,
    '2022-29-12': 1.0661,
    '2022-28-12': 1.0608,
    '2022-27-12': 1.0638,
    '2022-26-12': 1.0635,
    '2022-23-12': 1.0614,
    '2022-22-12': 1.0593,
    '2022-21-12': 1.0603,
    '2022-20-12': 1.0621,
    '2022-19-12': 1.0605,
    '2022-16-12': 1.0582,
    '2022-15-12': 1.0626,
    '2022-14-12': 1.0682,
    '2022-13-12': 1.063,
    '2022-12-12': 1.0535,
    '2022-09-12': 1.053,
    '2022-08-12': 1.0556,
    '2022-07-12': 1.0505,
    '2022-06-12': 1.0469,
    '2022-05-12': 1.0491,
    '2022-02-12': 1.0538,
    '2022-01-12': 1.0522,
    '2022-30-11': 1.0405,
    '2022-29-11': 1.0327,
    '2022-28-11': 1.0337,
    '2022-25-11': 1.0395,
    '2022-24-11': 1.0408,
    '2022-23-11': 1.0395,
    '2022-22-11': 1.0302,
    '2022-21-11': 1.0241,
    '2022-18-11': 1.0324,
    '2022-17-11': 1.036,
    '2022-16-11': 1.0392,
    '2022-15-11': 1.0348,
    '2022-14-11': 1.0325,
    '2022-11-11': 1.0352,
    '2022-10-11': 1.0208,
    '2022-09-11': 1.0011,
    '2022-08-11': 1.0072,
    '2022-07-11': 1.0019,
    '2022-04-11': 0.996,
    '2022-03-11': 0.9751,
    '2022-02-11': 0.9817,
    '2022-01-11': 0.9874,
    '2022-31-10': 0.9883,
    '2022-28-10': 0.9963,
    '2022-27-10': 0.9962,
    '2022-26-10': 1.0077,
    '2022-25-10': 0.9964,
    '2022-24-10': 0.9874,
    '2022-21-10': 0.986,
    '2022-20-10': 0.9783,
    '2022-19-10': 0.9771,
    '2022-18-10': 0.9852,
    '2022-17-10': 0.9838,
    '2022-14-10': 0.9719,
    '2022-13-10': 0.9773,
    '2022-12-10': 0.9704,
    '2022-11-10': 0.9703,
    '2022-10-10': 0.97,
    '2022-07-10': 0.9741,
    '2022-06-10': 0.9788,
    '2022-05-10': 0.9882,
    '2022-04-10': 0.9983,
    '2022-03-10': 0.9824,
    '2022-30-09': 0.9799,
    '2022-29-09': 0.9814,
    '2022-28-09': 0.9734,
    '2022-27-09': 0.9592,
    '2022-26-09': 0.9606,
    '2022-23-09': 0.969,
    '2022-22-09': 0.9836,
    '2022-21-09': 0.9837,
    '2022-20-09': 0.997,
    '2022-19-09': 1.0022,
    '2022-16-09': 1.0015,
    '2022-15-09': 0.9999,
    '2022-14-09': 0.9977,
    '2022-13-09': 0.997,
    '2022-12-09': 1.0119,
    '2022-09-09': 1.0039,
    '2022-08-09': 0.9994,
    '2022-07-09': 0.9999,
    '2022-06-09': 0.9902,
    '2022-05-09': 0.9926,
    '2022-02-09': 0.9951,
    '2022-01-09': 0.9944,
    '2022-31-08': 1.0057,
    '2022-30-08': 1.0012,
    '2022-29-08': 0.9995,
    '2022-26-08': 0.9961,
    '2022-25-08': 0.9974,
    '2022-24-08': 0.9965,
    '2022-23-08': 0.9967,
    '2022-22-08': 0.9941,
    '2022-19-08': 1.0034,
    '2022-18-08': 1.0088,
    '2022-17-08': 1.018,
    '2022-16-08': 1.017,
    '2022-15-08': 1.016,
    '2022-12-08': 1.0258,
    '2022-11-08': 1.0317,
    '2022-10-08': 1.0297,
    '2022-09-08': 1.0211,
    '2022-08-08': 1.0195,
    '2022-05-08': 1.0181,
    '2022-04-08': 1.0243,
    '2022-03-08': 1.0164,
    '2022-02-08': 1.0164,
    '2022-01-08': 1.0261,
    '2022-29-07': 1.0218,
    '2022-28-07': 1.0196,
    '2022-27-07': 1.0202,
    '2022-26-07': 1.0114,
    '2022-25-07': 1.022,
    '2022-22-07': 1.021,
    '2022-21-07': 1.0228,
    '2022-20-07': 1.0177,
    '2022-19-07': 1.0224,
    '2022-18-07': 1.0141,
    '2022-15-07': 1.0087,
    '2022-14-07': 1.0016,
    '2022-13-07': 1.006,
    '2022-12-07': 1.0036,
    '2022-11-07': 1.0039,
    '2022-08-07': 1.0183,
    '2022-07-07': 1.0159,
    '2022-06-07': 1.0181,
    '2022-05-07': 1.0266,
    '2022-04-07': 1.0421,
    '2022-01-07': 1.0428,
    '2022-30-06': 1.0482,
    '2022-29-06': 1.0439,
    '2022-28-06': 1.0518,
    '2022-27-06': 1.0583,
    '2022-24-06': 1.0554,
    '2022-23-06': 1.0523,
    '2022-22-06': 1.0565,
    '2022-21-06': 1.0525,
    '2022-20-06': 1.0509,
    '2022-17-06': 1.0498,
    '2022-16-06': 1.0547,
    '2022-15-06': 1.0443,
    '2022-14-06': 1.0414,
    '2022-13-06': 1.0408,
    '2022-10-06': 1.0515,
    '2022-09-06': 1.0614,
    '2022-08-06': 1.0714,
    '2022-07-06': 1.0699,
    '2022-06-06': 1.0694,
    '2022-03-06': 1.0718,
    '2022-02-06': 1.0745,
    '2022-01-06': 1.0646,
    '2022-31-05': 1.0733,
    '2022-30-05': 1.0777,
    '2022-27-05': 1.0727,
    '2022-26-05': 1.0724,
    '2022-25-05': 1.068,
    '2022-24-05': 1.0734,
    '2022-23-05': 1.0689,
    '2022-20-05': 1.056,
    '2022-19-05': 1.0586,
    '2022-18-05': 1.0466,
    '2022-17-05': 1.0547,
    '2022-16-05': 1.0431,
    '2022-13-05': 1.0411,
    '2022-12-05': 1.0379,
    '2022-11-05': 1.0511,
    '2022-10-05': 1.0527,
    '2022-09-05': 1.0555,
    '2022-06-05': 1.0551,
    '2022-05-05': 1.054,
    '2022-04-05': 1.0621,
    '2022-03-05': 1.052,
    '2022-02-05': 1.0504,
    '2022-29-04': 1.0541,
    '2022-28-04': 1.0494,
    '2022-27-04': 1.0555,
    '2022-26-04': 1.0636,
    '2022-25-04': 1.0711,
    '2022-22-04': 1.0794,
    '2022-21-04': 1.0836,
    '2022-20-04': 1.085,
    '2022-19-04': 1.0786,
    '2022-18-04': 1.078,
    '2022-15-04': 1.0806,
    '2022-14-04': 1.0827,
    '2022-13-04': 1.0885,
    '2022-12-04': 1.0826,
    '2022-11-04': 1.0883,
    '2022-08-04': 1.0876,
    '2022-07-04': 1.0878,
    '2022-06-04': 1.0893,
    '2022-05-04': 1.0903,
    '2022-04-04': 1.097,
    '2022-01-04': 1.1053,
    '2022-31-03': 1.1065,
    '2022-30-03': 1.1156,
    '2022-29-03': 1.1085,
    '2022-28-03': 1.0978,
    '2022-25-03': 1.0981,
    '2022-24-03': 1.0996,
    '2022-23-03': 1.1004,
    '2022-22-03': 1.1027,
    '2022-21-03': 1.1014,
    '2022-18-03': 1.1055,
    '2022-17-03': 1.1089,
    '2022-16-03': 1.1032,
    '2022-15-03': 1.0951,
    '2022-14-03': 1.0939,
    '2022-11-03': 1.0909,
    '2022-10-03': 1.0983,
    '2022-09-03': 1.1075,
    '2022-08-03': 1.0899,
    '2022-07-03': 1.0852,
    '2022-04-03': 1.0926,
    '2022-03-03': 1.1064,
    '2022-02-03': 1.1121,
    '2022-01-03': 1.1126,
    '2022-28-02': 1.1219,
    '2022-25-02': 1.1267,
    '2022-24-02': 1.1191,
    '2022-23-02': 1.1309,
    '2022-22-02': 1.1325,
    '2022-21-02': 1.131,
    '2022-18-02': 1.1321,
    '2022-17-02': 1.136,
    '2022-16-02': 1.1373,
    '2022-15-02': 1.1356,
    '2022-14-02': 1.1305,
    '2022-11-02': 1.1349,
    '2022-10-02': 1.1427,
    '2022-09-02': 1.1422,
    '2022-08-02': 1.1414,
    '2022-07-02': 1.1442,
    '2022-04-02': 1.1446,
    '2022-03-02': 1.1438,
    '2022-02-02': 1.1303,
    '2022-01-02': 1.1269,
    '2022-31-01': 1.1233,
    '2022-28-01': 1.1143,
    '2022-27-01': 1.1143,
    '2022-26-01': 1.1237,
    '2022-25-01': 1.1299,
    '2022-24-01': 1.1323,
    '2022-21-01': 1.134,
    '2022-20-01': 1.131,
    '2022-19-01': 1.1341,
    '2022-18-01': 1.1325,
    '2022-17-01': 1.1407,
    '2022-14-01': 1.1414,
    '2022-13-01': 1.1453,
    '2022-12-01': 1.1442,
    '2022-11-01': 1.1364,
    '2022-10-01': 1.1324,
    '2022-07-01': 1.1359,
    '2022-06-01': 1.1291,
    '2022-05-01': 1.1313,
    '2022-04-01': 1.1285,
    '2022-03-01': 1.1294,
    '2021-31-12': 1.1368,
    '2021-30-12': 1.1323,
    '2021-29-12': 1.1348,
    '2021-28-12': 1.1309,
    '2021-27-12': 1.1325,
    '2021-24-12': 1.1317,
    '2021-23-12': 1.1328,
    '2021-22-12': 1.1324,
    '2021-21-12': 1.1283,
    '2021-20-12': 1.1275,
    '2021-17-12': 1.1239,
    '2021-16-12': 1.1328,
    '2021-15-12': 1.1285,
    '2021-14-12': 1.1257,
    '2021-13-12': 1.1283,
    '2021-10-12': 1.1311,
    '2021-09-12': 1.1292,
    '2021-08-12': 1.1342,
    '2021-07-12': 1.1263,
    '2021-06-12': 1.1285,
    '2021-03-12': 1.1313,
    '2021-02-12': 1.1299,
    '2021-01-12': 1.1319,
    '2021-30-11': 1.1336,
    '2021-29-11': 1.1291,
    '2021-26-11': 1.1317,
    '2021-25-11': 1.1206,
    '2021-24-11': 1.1197,
    '2021-23-11': 1.1246,
    '2021-22-11': 1.1234,
    '2021-19-11': 1.1288,
    '2021-18-11': 1.1369,
    '2021-17-11': 1.1319,
    '2021-16-11': 1.1319,
    '2021-15-11': 1.1367,
    '2021-12-11': 1.145,
    '2021-11-11': 1.145,
    '2021-10-11': 1.1478,
    '2021-09-11': 1.1591,
    '2021-08-11': 1.1586,
    '2021-05-11': 1.1566,
    '2021-04-11': 1.1552,
    '2021-03-11': 1.161,
    '2021-02-11': 1.1577,
    '2021-01-11': 1.1606,
    '2021-29-10': 1.1561,
    '2021-28-10': 1.1679,
    '2021-27-10': 1.1604,
    '2021-26-10': 1.1595,
    '2021-25-10': 1.1606,
    '2021-22-10': 1.1647,
    '2021-21-10': 1.1621,
    '2021-20-10': 1.1649,
    '2021-19-10': 1.1632,
    '2021-18-10': 1.1609,
    '2021-15-10': 1.16,
    '2021-14-10': 1.1594,
    '2021-13-10': 1.1592,
    '2021-12-10': 1.1527,
    '2021-11-10': 1.1551,
    '2021-08-10': 1.1567,
    '2021-07-10': 1.155,
    '2021-06-10': 1.1556,
    '2021-05-10': 1.1596,
    '2021-04-10': 1.1621,
    '2021-01-10': 1.1594,
    '2021-30-09': 1.1581,
    '2021-29-09': 1.1595,
    '2021-28-09': 1.1681,
    '2021-27-09': 1.1694,
    '2021-24-09': 1.1714,
    '2021-23-09': 1.1736,
    '2021-22-09': 1.1686,
    '2021-21-09': 1.1723,
    '2021-20-09': 1.1725,
    '2021-17-09': 1.1725,
    '2021-16-09': 1.1764,
    '2021-15-09': 1.1815,
    '2021-14-09': 1.1802,
    '2021-13-09': 1.1808,
    '2021-10-09': 1.1814,
    '2021-09-09': 1.1825,
    '2021-08-09': 1.1813,
    '2021-07-09': 1.1839,
    '2021-06-09': 1.1868,
    '2021-03-09': 1.1882,
    '2021-02-09': 1.1873,
    '2021-01-09': 1.1837,
    '2021-31-08': 1.1807,
    '2021-30-08': 1.1795,
    '2021-27-08': 1.1793,
    '2021-26-08': 1.175,
    '2021-25-08': 1.177,
    '2021-24-08': 1.1753,
    '2021-23-08': 1.1743,
    '2021-20-08': 1.1696,
    '2021-19-08': 1.1674,
    '2021-18-08': 1.171,
    '2021-17-08': 1.1708,
    '2021-16-08': 1.1777,
    '2021-13-08': 1.1791,
    '2021-12-08': 1.1727,
    '2021-11-08': 1.1737,
    '2021-10-08': 1.1718,
    '2021-09-08': 1.1737,
    '2021-06-08': 1.176,
    '2021-05-08': 1.1832,
    '2021-04-08': 1.1835,
    '2021-03-08': 1.186,
    '2021-02-08': 1.1867,
    '2021-30-07': 1.187,
    '2021-29-07': 1.1886,
    '2021-28-07': 1.1842,
    '2021-27-07': 1.1814,
    '2021-26-07': 1.1799,
    '2021-23-07': 1.1771,
    '2021-22-07': 1.177,
    '2021-21-07': 1.1792,
    '2021-20-07': 1.1779,
    '2021-19-07': 1.1798,
    '2021-16-07': 1.1805,
    '2021-15-07': 1.1812,
    '2021-14-07': 1.1835,
    '2021-13-07': 1.1774,
    '2021-12-07': 1.1859,
    '2021-09-07': 1.1873,
    '2021-08-07': 1.1842,
    '2021-07-07': 1.1789,
    '2021-06-07': 1.1822,
    '2021-05-07': 1.1861,
    '2021-02-07': 1.1864,
    '2021-01-07': 1.1848,
    '2021-30-06': 1.1855,
    '2021-29-06': 1.1895,
    '2021-28-06': 1.1924,
    '2021-25-06': 1.1933,
    '2021-24-06': 1.193,
    '2021-23-06': 1.1925,
    '2021-22-06': 1.1938,
    '2021-21-06': 1.1915,
    '2021-18-06': 1.186,
    '2021-17-06': 1.1906,
    '2021-16-06': 1.1994,
    '2021-15-06': 1.2124,
    '2021-14-06': 1.2118,
    '2021-11-06': 1.2106,
    '2021-10-06': 1.2169,
    '2021-09-06': 1.2178,
    '2021-08-06': 1.2171,
    '2021-07-06': 1.2189,
    '2021-04-06': 1.2165,
    '2021-03-06': 1.2124,
    '2021-02-06': 1.2209,
    '2021-01-06': 1.2211,
    '2021-31-05': 1.2225,
    '2021-28-05': 1.2189,
    '2021-27-05': 1.2192,
    '2021-26-05': 1.219,
    '2021-25-05': 1.225,
    '2021-24-05': 1.2215,
    '2021-21-05': 1.2179,
    '2021-20-05': 1.2226,
    '2021-19-05': 1.2172,
    '2021-18-05': 1.222,
    '2021-17-05': 1.2151,
    '2021-14-05': 1.214,
    '2021-13-05': 1.2078,
    '2021-12-05': 1.2069,
    '2021-11-05': 1.2146,
    '2021-10-05': 1.2129,
    '2021-07-05': 1.2163,
    '2021-06-05': 1.2064,
    '2021-05-05': 1.2005,
    '2021-04-05': 1.2013,
    '2021-03-05': 1.2061,
    '2021-30-04': 1.2018,
    '2021-29-04': 1.2118,
    '2021-28-04': 1.2123,
    '2021-27-04': 1.209,
    '2021-26-04': 1.2083,
    '2021-23-04': 1.2099,
    '2021-22-04': 1.2015,
    '2021-21-04': 1.2033,
    '2021-20-04': 1.2033,
    '2021-19-04': 1.2033,
    '2021-16-04': 1.1983,
    '2021-15-04': 1.1965,
    '2021-14-04': 1.1978,
    '2021-13-04': 1.1946,
    '2021-12-04': 1.1909,
    '2021-09-04': 1.1896,
    '2021-08-04': 1.1912,
    '2021-07-04': 1.187,
    '2021-06-04': 1.1875,
    '2021-05-04': 1.1811,
    '2021-02-04': 1.1762,
    '2021-01-04': 1.1775,
    '2021-31-03': 1.1728,
    '2021-30-03': 1.1714,
    '2021-29-03': 1.1762,
    '2021-26-03': 1.1796,
    '2021-25-03': 1.1764,
    '2021-24-03': 1.1812,
    '2021-23-03': 1.1849,
    '2021-22-03': 1.1931,
    '2021-19-03': 1.1903,
    '2021-18-03': 1.1915,
    '2021-17-03': 1.1978,
    '2021-16-03': 1.19,
    '2021-15-03': 1.1928,
    '2021-12-03': 1.1952,
    '2021-11-03': 1.1984,
    '2021-10-03': 1.1925,
    '2021-09-03': 1.1898,
    '2021-08-03': 1.1843,
    '2021-05-03': 1.1917,
    '2021-04-03': 1.1966,
    '2021-03-03': 1.2062,
    '2021-02-03': 1.2089,
    '2021-01-03': 1.2047,
    '2021-26-02': 1.2074,
    '2021-25-02': 1.2176,
    '2021-24-02': 1.2164,
    '2021-23-02': 1.2149,
    '2021-22-02': 1.2154,
    '2021-19-02': 1.2117,
    '2021-18-02': 1.2088,
    '2021-17-02': 1.2036,
    '2021-16-02': 1.2104,
    '2021-15-02': 1.2127,
    '2021-12-02': 1.2118,
    '2021-11-02': 1.2128,
    '2021-10-02': 1.2116,
    '2021-09-02': 1.2117,
    '2021-08-02': 1.2048,
    '2021-05-02': 1.2042,
    '2021-04-02': 1.1962,
    '2021-03-02': 1.2034,
    '2021-02-02': 1.2042,
    '2021-01-02': 1.2059,
    '2021-29-01': 1.2136,
    '2021-28-01': 1.2121,
    '2021-27-01': 1.2108,
    '2021-26-01': 1.216,
    '2021-25-01': 1.2137,
    '2021-22-01': 1.2167,
    '2021-21-01': 1.2162,
    '2021-20-01': 1.2104,
    '2021-19-01': 1.2128,
    '2021-18-01': 1.2076,
    '2021-15-01': 1.2078,
    '2021-14-01': 1.2156,
    '2021-13-01': 1.2157,
    '2021-12-01': 1.2207,
    '2021-11-01': 1.2149,
    '2021-08-01': 1.2218,
    '2021-07-01': 1.227,
    '2021-06-01': 1.2325,
    '2021-05-01': 1.2294,
    '2021-04-01': 1.2248,
    '2021-01-01': 1.2212,
    '2020-31-12': 1.2213,
    '2020-30-12': 1.2295,
    '2020-29-12': 1.2247,
    '2020-28-12': 1.2214,
    '2020-25-12': 1.2204,
    '2020-24-12': 1.2186,
    '2020-23-12': 1.2185,
    '2020-22-12': 1.2161,
    '2020-21-12': 1.2242,
    '2020-18-12': 1.2255,
    '2020-17-12': 1.2266,
    '2020-16-12': 1.2197,
    '2020-15-12': 1.2151,
    '2020-14-12': 1.2143,
    '2020-11-12': 1.2111,
    '2020-10-12': 1.2136,
    '2020-09-12': 1.2081,
    '2020-08-12': 1.2101,
    '2020-07-12': 1.2108,
    '2020-04-12': 1.212,
    '2020-03-12': 1.214,
    '2020-02-12': 1.2115,
    '2020-01-12': 1.207,
    '2020-30-11': 1.1928,
    '2020-27-11': 1.1962,
    '2020-26-11': 1.1913,
    '2020-25-11': 1.1913,
    '2020-24-11': 1.1888,
    '2020-23-11': 1.184,
    '2020-20-11': 1.1853,
    '2020-19-11': 1.1873,
    '2020-18-11': 1.1852,
    '2020-17-11': 1.1861,
    '2020-16-11': 1.1853,
    '2020-13-11': 1.1832,
    '2020-12-11': 1.1804,
    '2020-11-11': 1.1777,
    '2020-10-11': 1.1814,
    '2020-09-11': 1.1813,
    '2020-06-11': 1.1872,
    '2020-05-11': 1.1821,
    '2020-04-11': 1.1722,
    '2020-03-11': 1.1711,
    '2020-02-11': 1.164,
    '2020-30-10': 1.1647,
    '2020-29-10': 1.1674,
    '2020-28-10': 1.1744,
    '2020-27-10': 1.1795,
    '2020-26-10': 1.1808,
    '2020-23-10': 1.1859,
    '2020-22-10': 1.1816,
    '2020-21-10': 1.1861,
    '2020-20-10': 1.1821,
    '2020-19-10': 1.1766,
    '2020-16-10': 1.1718,
    '2020-15-10': 1.1706,
    '2020-14-10': 1.1746,
    '2020-13-10': 1.1744,
    '2020-12-10': 1.1813,
    '2020-09-10': 1.1824,
    '2020-08-10': 1.1758,
    '2020-07-10': 1.176,
    '2020-06-10': 1.1734,
    '2020-05-10': 1.1781,
    '2020-02-10': 1.1713,
    '2020-01-10': 1.1747,
    '2020-30-09': 1.1718,
    '2020-29-09': 1.1742,
    '2020-28-09': 1.1664,
    '2020-25-09': 1.163,
    '2020-24-09': 1.1672,
    '2020-23-09': 1.1659,
    '2020-22-09': 1.1706,
    '2020-21-09': 1.1769,
    '2020-18-09': 1.1837,
    '2020-17-09': 1.1847,
    '2020-16-09': 1.1814,
    '2020-15-09': 1.1845,
    '2020-14-09': 1.1868,
    '2020-11-09': 1.1845,
    '2020-10-09': 1.1813,
    '2020-09-09': 1.1802,
    '2020-08-09': 1.1779,
    '2020-07-09': 1.1817,
    '2020-04-09': 1.1838,
    '2020-03-09': 1.1849,
    '2020-02-09': 1.1853,
    '2020-01-09': 1.191,
    '2020-31-08': 1.1936,
    '2020-28-08': 1.1903,
    '2020-27-08': 1.1821,
    '2020-26-08': 1.1829,
    '2020-25-08': 1.1833,
    '2020-24-08': 1.1787,
    '2020-21-08': 1.1795,
    '2020-20-08': 1.1859,
    '2020-19-08': 1.1836,
    '2020-18-08': 1.1929,
    '2020-17-08': 1.1869,
    '2020-14-08': 1.1841,
    '2020-13-08': 1.1812,
    '2020-12-08': 1.1782,
    '2020-11-08': 1.1739,
    '2020-10-08': 1.1736,
    '2020-07-08': 1.1786,
    '2020-06-08': 1.1875,
    '2020-05-08': 1.1861,
    '2020-04-08': 1.18,
    '2020-03-08': 1.1761,
    '2020-31-07': 1.1774,
    '2020-30-07': 1.1846,
    '2020-29-07': 1.179,
    '2020-28-07': 1.1714,
    '2020-27-07': 1.1751,
    '2020-24-07': 1.1654,
    '2020-23-07': 1.1594,
    '2020-22-07': 1.1568,
    '2020-21-07': 1.1526,
    '2020-20-07': 1.1444,
    '2020-17-07': 1.1426,
    '2020-16-07': 1.1383,
    '2020-15-07': 1.141,
    '2020-14-07': 1.1396,
    '2020-13-07': 1.134,
    '2020-10-07': 1.1298,
    '2020-09-07': 1.1281,
    '2020-08-07': 1.1329,
    '2020-07-07': 1.127,
    '2020-06-07': 1.1308,
    '2020-03-07': 1.1248,
    '2020-02-07': 1.1238,
    '2020-01-07': 1.125,
    '2020-30-06': 1.1231,
    '2020-29-06': 1.124,
    '2020-26-06': 1.1217,
    '2020-25-06': 1.1217,
    '2020-24-06': 1.125,
    '2020-23-06': 1.1306,
    '2020-22-06': 1.1258,
    '2020-19-06': 1.1175,
    '2020-18-06': 1.1202,
    '2020-17-06': 1.1243,
    '2020-16-06': 1.1263,
    '2020-15-06': 1.1322,
    '2020-12-06': 1.1254,
    '2020-11-06': 1.1297,
    '2020-10-06': 1.1369,
    '2020-09-06': 1.134,
    '2020-08-06': 1.1292,
    '2020-05-06': 1.1284,
    '2020-04-06': 1.1336,
    '2020-03-06': 1.1232,
    '2020-02-06': 1.1169,
    '2020-01-06': 1.1134,
    '2020-29-05': 1.1098,
    '2020-28-05': 1.1076,
    '2020-27-05': 1.1003,
    '2020-26-05': 1.098,
    '2020-25-05': 1.0899,
    '2020-22-05': 1.09,
    '2020-21-05': 1.0949,
    '2020-20-05': 1.0977,
    '2020-19-05': 1.0921,
    '2020-18-05': 1.0912,
    '2020-15-05': 1.0815,
    '2020-14-05': 1.0804,
    '2020-13-05': 1.0816,
    '2020-12-05': 1.0846,
    '2020-11-05': 1.0806,
    '2020-08-05': 1.084,
    '2020-07-05': 1.0832,
    '2020-06-05': 1.0794,
    '2020-05-05': 1.0838,
    '2020-04-05': 1.0906,
    '2020-01-05': 1.0983,
    '2020-30-04': 1.0955,
    '2020-29-04': 1.0873,
    '2020-28-04': 1.0818,
    '2020-27-04': 1.0828,
    '2020-24-04': 1.082,
    '2020-23-04': 1.0776,
    '2020-22-04': 1.0822,
    '2020-21-04': 1.0856,
    '2020-20-04': 1.0862,
    '2020-17-04': 1.0876,
    '2020-16-04': 1.0835,
    '2020-15-04': 1.0907,
    '2020-14-04': 1.0979,
    '2020-13-04': 1.0913,
    '2020-10-04': 1.0935,
    '2020-09-04': 1.0927,
    '2020-08-04': 1.0856,
    '2020-07-04': 1.0889,
    '2020-06-04': 1.0791,
    '2020-03-04': 1.0808,
    '2020-02-04': 1.0856,
    '2020-01-04': 1.0962,
    '2020-31-03': 1.1029,
    '2020-30-03': 1.1046,
    '2020-27-03': 1.114,
    '2020-26-03': 1.1028,
    '2020-25-03': 1.088,
    '2020-24-03': 1.0787,
    '2020-23-03': 1.0721,
    '2020-20-03': 1.0694,
    '2020-19-03': 1.069,
    '2020-18-03': 1.0913,
    '2020-17-03': 1.0996,
    '2020-16-03': 1.1181,
    '2020-13-03': 1.1105,
    '2020-12-03': 1.1183,
    '2020-11-03': 1.1267,
    '2020-10-03': 1.1279,
    '2020-09-03': 1.1447,
    '2020-06-03': 1.1285,
    '2020-05-03': 1.1239,
    '2020-04-03': 1.1134,
    '2020-03-03': 1.1171,
    '2020-02-03': 1.1132,
    '2020-28-02': 1.1025,
    '2020-27-02': 1.0998,
    '2020-26-02': 1.0879,
    '2020-25-02': 1.0879,
    '2020-24-02': 1.0852,
    '2020-21-02': 1.0843,
    '2020-20-02': 1.0783,
    '2020-19-02': 1.0804,
    '2020-18-02': 1.0791,
    '2020-17-02': 1.0834,
    '2020-14-02': 1.083,
    '2020-13-02': 1.084,
    '2020-12-02': 1.0871,
    '2020-11-02': 1.0914,
    '2020-10-02': 1.0909,
    '2020-07-02': 1.0943,
    '2020-06-02': 1.098,
    '2020-05-02': 1.0997,
    '2020-04-02': 1.1042,
    '2020-03-02': 1.1058,
    '2020-31-01': 1.1093,
    '2020-30-01': 1.103,
    '2020-29-01': 1.1009,
    '2020-28-01': 1.102,
    '2020-27-01': 1.1016,
    '2020-24-01': 1.1023,
    '2020-23-01': 1.1052,
    '2020-22-01': 1.1091,
    '2020-21-01': 1.1082,
    '2020-20-01': 1.1094,
    '2020-17-01': 1.1088,
    '2020-16-01': 1.1135,
    '2020-15-01': 1.1149,
    '2020-14-01': 1.1127,
    '2020-13-01': 1.1133,
    '2020-10-01': 1.112,
    '2020-09-01': 1.1105,
    '2020-08-01': 1.1103,
    '2020-07-01': 1.1151,
    '2020-06-01': 1.1193,
    '2020-03-01': 1.1158,
    '2020-02-01': 1.117,
    '2020-01-01': 1.121,
}
